import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GenericComponent } from '../generic/generic.component';

@Injectable({
  providedIn: 'root'
})
export class GenericControlService {

  constructor(private modalService: BsModalService) { }

  showMesssageModal(entity:string){
    const bsModalRef : BsModalRef = this.modalService.show(GenericComponent);
    bsModalRef.content.entity = entity;
  }
}
